import type {
  PolycardContractContext,
  PolycardContractInterface,
} from '@polycard/card';
import type { Metrics } from '../../../../../utils/contracts';
import type { DeviceType, OsNames } from '../../../../utils/utils';

import RedirectApp from 'redirect-app-web';

import { Header } from '../../../../components/Header';
import {
  getServerSideProps,
  setPageSettings,
} from '../../../../server/hooks/list-detail';
import { AppProvider } from '../../../../providers/AppProvider';
import { ListDetail } from '../../../../components/ListDetail';
import { PaginationProvider } from '../../../../providers/Pagination';

interface OpenInApp {
  shouldRedirect: boolean;
}

interface ListProps {
  isOwner: boolean;
  deviceType: DeviceType;
  env: string;
  headerProps: Record<string, unknown>;
  listId: string;
  metrics: Metrics;
  polycardContext?: PolycardContractContext;
  polycards?: Array<PolycardContractInterface>;
  profilePath: string;
  totalItems: number;
  shareLink: string;
  limit?: string;
  osName: OsNames;
  siteId: string;
  domain: string;
  listOwnerId: string;
  listName: string;
  userId: number;
  page: string;
  urlLists: string;
  openInApp: OpenInApp;
}

const List = ({
  deviceType,
  env,
  listId,
  metrics,
  polycardContext,
  polycards,
  profilePath,
  headerProps,
  isOwner,
  totalItems,
  shareLink,
  limit,
  osName,
  siteId,
  domain,
  listOwnerId,
  listName,
  userId,
  urlLists,
  page,
  openInApp,
}: ListProps) => (
  <div>
    {openInApp?.shouldRedirect && <RedirectApp {...openInApp} />}
    <AppProvider envParam={env} trackingIdParam={metrics.tracking_id || ''}>
      {headerProps && (
        <Header {...headerProps} device_type={deviceType} siteId={siteId} />
      )}
      <div className="lists">
        <div className="lists-container">
          <PaginationProvider
            env={env}
            listId={listId}
            isWebviewInint={false}
            polycards={polycards || []}
            profilePath={profilePath}
            totalItemsInit={totalItems}
            isListDetailInit
            limit={limit}
            userId={userId}
          >
            <ListDetail
              deviceType={deviceType}
              isOwner={isOwner}
              listId={listId}
              metrics={metrics}
              osName={osName}
              shareLink={shareLink}
              polycardContext={polycardContext}
              polycards={polycards}
              domain={domain}
              listOwnerId={listOwnerId}
              listName={listName}
              urlLists={urlLists}
              page={page}
            />
          </PaginationProvider>
        </div>
      </div>
    </AppProvider>
  </div>
);

export const hydrate = 'hydrateRoot';

export { getServerSideProps, setPageSettings };

export default List;
